import { SearchOutlined } from '@ant-design/icons'
import { Button, Input } from 'antd'
import styled from 'styled-components'
import { IconFont } from '../iconfont'

interface InputProps extends React.ComponentProps<typeof Input> {}

interface ButtonProps extends React.ComponentProps<typeof Button> {}

interface SearchInputProps {
  containerProps?: typeof SearchInputContainer
  inputProps?: InputProps
  buttonProps?: ButtonProps
  style?: React.CSSProperties
}

export const SearchInput = (props: SearchInputProps) => {
  const { inputProps, buttonProps, containerProps, style } = props
  return (
    <SearchInputContainer {...containerProps} style={style}>
      <Input.Group compact style={{ display: 'flex', height: '32px' }}>
        <FlexInput
          {...inputProps}
          prefix={<IconFont type="icon-sousuo1" style={{ color: '#666', fontSize: 16 }} />}
        />
      </Input.Group>
    </SearchInputContainer>
  )
}

const SearchInputContainer = styled.div`
  width: 230px;
`

const FlexInput = styled(Input)`
  flex-grow: 1;
`

const SearchBtn = styled(Button)`
  font-size: 17px;
  width: 32px;
  min-width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 0 6px 6px 0 !important;
  display: flex;
  justify-content: center;
  transform: translateX(-1px);
`
